import React, { lazy } from 'react';
import { MapPin } from 'lucide-react';
export function ServiceArea() {
  const cities = ['Dallas', 'Fort Worth', 'Arlington', 'Plano', 'Irving', 'Garland', 'Frisco', 'McKinney', 'Grand Prairie', 'Denton', 'Mesquite', 'Carrollton', 'Richardson', 'Lewisville', 'Allen', 'Flower Mound', 'Grapevine', 'Southlake'];
  return <section id="service-area" className="py-20 bg-white" data-id="element-216">
      <div className="container mx-auto px-4" data-id="element-217">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-218">
          <div data-id="element-219">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-tx-light text-tx-navy font-bold rounded-full text-sm mb-6" data-id="element-220">
              <MapPin className="w-4 h-4" data-id="element-221" />
              Local DFW Contractor
            </div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold text-tx-deep mb-6 tracking-tight" data-id="element-222">
              Proudly Serving Dallas Fort Worth
            </h2>
            <p className="text-lg text-tx-body leading-relaxed mb-8" data-id="element-223">
              With our headquarters in Hurst and multiple locations across the
              metroplex, our crews are always nearby when you need us. We
              provide fast, reliable roofing services to homeowners throughout
              the DFW area.
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-y-3 gap-x-4" data-id="element-224">
              {cities.map((city, index) => <div key={index} className="flex items-center gap-2 text-gray-600" data-id="element-225">
                  <div className="w-1.5 h-1.5 rounded-full bg-tx-red" data-id="element-226"></div>
                  {city}
                </div>)}
            </div>
          </div>

          <div className="relative rounded-2xl overflow-hidden shadow-xl aspect-square lg:aspect-auto lg:h-[600px]" data-id="element-227">
            <iframe title="Texas Direct Roofing & Construction location in Hurst, TX" src="https://maps.google.com/maps?cid=10366412453173533568&hl=en&z=12&output=embed" className="w-full h-full border-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen data-id="element-228"></iframe>

            {/* Overlay card */}
            <div className="absolute bottom-8 left-8 right-8 bg-white p-6 rounded-xl shadow-lg pointer-events-none" data-id="element-229">
              <h3 className="font-bold text-tx-deep text-lg mb-2" data-id="element-230">
                Hurst Headquarters
              </h3>
              <p className="text-gray-600 text-sm" data-id="element-231">
                231 NE Loop 820
                <br data-id="element-232" />
                Hurst, TX 76053
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}